import React, { useEffect, useRef, useState, useMemo } from 'react';
import {
  Typography,
  Box,
  Divider,
  Paper,
  Collapse,
  IconButton
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RouteIcon from '@mui/icons-material/Route';
import PropTypes from 'prop-types';
import './GetRates.css';
import { useSelector } from 'react-redux';
import { GetActiveCarriers } from '../../apis/Agency';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { base_url } from '../../apis/constants';
import QuickQuoteTabPanel from './QuickQuoteTabPanel';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';

function QuickQuoteRates(props) {
  const obj = props.location.state.state;
  const deepCloneObj = props.location.state.deepClone;
  const totalWeightLBS = props.location.state.totalLBSWeight;
  const quote = props.location.state.quote;
  const SelectedRowData = props.location?.state?.DataToShow;
  const selectedLocation = props.location?.state?.selectedLocation;
  const selectedClass =
    props.location?.state?.state?.commodityInfo[0].freightClass;
  const shipTypeValue = props.location?.state?.shipTypeValue;
  const [EstesApiLoading, setEstesApiLoading] = useState(false);
  const locationId = props.location?.state?.locationId;

  const [GetRatesArray, setGetRatesArray] = useState([]);
  const [finalCarrierApis, setFinalCarrierApis] = useState([]);
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const [data, setData] = useState([]);
  const [errorMessageApi, setErrorMessageApi] = useState([]);
  const [successRates, setSuccessRates] = useState([]);
  const [noAssignedCarriers, setNoAssignedCarriers] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const dispatch = useDispatch();

  const OriginLocation =
    obj.shipFrom.city +
    ' ' +
    obj.shipFrom.stateOrProvinceCode +
    ' ' +
    obj.shipFrom.postalCode +
    ' ' +
    obj.shipFrom.countryCode;

  const DestinationLocation =
    obj.shipTo.city +
    ' ' +
    obj.shipTo.stateOrProvinceCode +
    ' ' +
    obj.shipTo.postalCode +
    ' ' +
    obj.shipTo.countryCode;

  const OrderWeight = totalWeightLBS;
  const [originLoc, setOriginLoc] = useState(OriginLocation);
  const [destinationLoc, setDestinationLoc] = useState(DestinationLocation);
  const [requoteWeight, setRequoteWeight] = useState(OrderWeight);

  const options = {
    month: 'short',
    day: 'numeric'
  };

  const uniqueIdCounterRef = useRef(1);

  const handleSuccessResponse = (ApiRes, count) => {
    let calledSuccess = 0 + count;
    if (calledSuccess === finalCarrierApis.length) {
      console.log('loop completed');
    }
    setEstesApiLoading(false);
    ApiRes.data.shipmentDetails.forEach(shipmentDetail => {
      const uniqueId = uniqueIdCounterRef.current;
      uniqueIdCounterRef.current = uniqueIdCounterRef.current + 1;

      const formattedDate = new Date(shipmentDetail.deliveryTime)
        .toLocaleString('en-US', options)
        .toUpperCase();
      const yearLastTwoDigits = formattedDate.slice(-2);

      setSuccessRates(prevArray => [
        ...prevArray,
        {
          ...shipmentDetail,
          uniqueId: uniqueId,
          udeliveryTime: shipmentDetail.deliveryTime
            ? formattedDate.replace(yearLastTwoDigits, `${yearLastTwoDigits}`)
            : '',
          filterMode: !shipmentDetail.isGuaranteedDelviery
            ? 'standard'
            : shipmentDetail.isGuaranteedDelviery &&
                shipmentDetail.serviceType?.includes('5')
              ? 'g5'
              : shipmentDetail.isGuaranteedDelviery &&
                  shipmentDetail.serviceType?.includes('10')
                ? 'g10'
                : shipmentDetail.isGuaranteedDelviery &&
                    shipmentDetail.serviceType?.includes('12')
                  ? 'g12'
                  : 'other'
        }
      ]);
    });
  };

  let tempErr = [];

  const handleRejectRepsone = err => {
    const ErrObj = {
      message: err?.response?.data,
      URL: err?.response?.request?.responseURL
    };
    tempErr.push(ErrObj);
    if (tempErr.length === finalCarrierApis.length) {
      setChecked(true);
    }
    setErrorMessageApi(prevArray => [...prevArray, ErrObj]);
    setEstesApiLoading(false);
  };

  const fetchData = async (RequoteObj, DeepCloneRequoteObj) => {
    const GetAuthToken = () => sessionStorage.getItem('UserAuthToken');

    const AgencyLoginHeader = axios.create({
      baseURL: base_url,
      responseType: 'json'
    });

    AgencyLoginHeader.interceptors.request.use(
      async config => {
        const authToken = GetAuthToken();
        if (authToken) config.headers.Authorization = `Bearer ${authToken}`;
        return config;
      },
      error => Promise.reject(error)
    );

    setData([]);
    setSuccessRates([]);
    setGetRatesArray([]);
    setErrorMessageApi([]);

    if (RequoteObj !== undefined) {
      setOriginLoc(
        RequoteObj.shipFrom.city +
          ' ' +
          RequoteObj.shipFrom.stateOrProvinceCode +
          ' ' +
          RequoteObj.shipFrom.postalCode +
          ' ' +
          RequoteObj.shipFrom.countryCode
      );
      setDestinationLoc(
        RequoteObj.shipTo.city +
          ' ' +
          RequoteObj.shipTo.stateOrProvinceCode +
          ' ' +
          RequoteObj.shipTo.postalCode +
          ' ' +
          RequoteObj.shipTo.countryCode
      );
      setRequoteWeight(RequoteObj?.commodityInfo[0]?.weight?.value);
    }

    finalCarrierApis.length > 0
      ? setEstesApiLoading(true)
      : setEstesApiLoading(false);

    for (let i = 0; i < finalCarrierApis.length; i++) {
      const EndPoint = finalCarrierApis[i];
      RequoteObj !== undefined
        ? AgencyLoginHeader.post(EndPoint, RequoteObj)
            .then(res => res.status === 200 && handleSuccessResponse(res, i))
            .catch(err => handleRejectRepsone(err))
        : AgencyLoginHeader.post(EndPoint, obj)
            .then(res => res.status === 200 && handleSuccessResponse(res, i))
            .catch(err => handleRejectRepsone(err));
    }
  };

  const handleGetCarrierNames = data => {
    let tempApis = [];
    let CarrierArray = [];
    if (shipTypeValue == 'LTL') {
      CarrierArray = data.filter(
        items => items.active && items.cType === 'LTL'
      );
    } else {
      CarrierArray = data.filter(
        items => items.active && items.cType === 'Parcel'
      );
    }
    if (CarrierArray.length === 0) {
      setNoAssignedCarriers(true);
    } else {
      setNoAssignedCarriers(false);
    }
    for (let i = 0; i < CarrierArray.length; i++) {
      const CarrierName = CarrierArray[i]?.getRateEndPoint?.replace('/', '');
      tempApis.push(base_url + CarrierName);
    }
    setFinalCarrierApis(tempApis);
  };

  useEffect(() => {
    setEstesApiLoading(true);
    fetchData();
  }, [finalCarrierApis]);

  useEffect(() => {
    GetActiveCarriers(AgencyID, locationId)
      .then(res => res.status === 200 && handleGetCarrierNames(res.data.data))
      .catch(err => console.log('Error fetching carriers:', err));
  }, []);

  const [checked, setChecked] = useState(false);
  const isMobile = useIsMobile();

  // Quote totals computed from live successRates
  const quoteTotals = useMemo(() => {
    if (successRates.length === 0) return null;
    const prices = successRates
      .map(r => r.totalNetCharge?.amount)
      .filter(p => p != null && !isNaN(p));
    const transits = successRates
      .map(r => parseInt(r.transitTime))
      .filter(t => !isNaN(t) && t > 0);
    return {
      totalResults: successRates.length,
      lowestPrice: prices.length ? Math.min(...prices) : null,
      fastestTransit: transits.length ? Math.min(...transits) : null,
      averagePrice: prices.length
        ? prices.reduce((a, b) => a + b, 0) / prices.length
        : null
    };
  }, [successRates]);

  const formatCurrency = val =>
    val != null
      ? val.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      : '-';

  const summaryRows = [
    { label: 'Weight', value: `${totalWeightLBS?.toLocaleString()} lbs` },
    {
      label: 'Hazmat',
      value: obj.isHazmat ? 'Yes' : 'No',
      valueColor: obj.isHazmat ? '#ef4444' : undefined
    }
  ];

  const commodityRows =
    shipTypeValue !== 'Parcel' ? obj.commodityInfo || [] : [];

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        p: isMobile ? 1 : 2,
        alignItems: 'flex-start',
        minHeight: '80vh'
      }}
    >
      {/* ── Left Sidebar ── */}
      {!isMobile && (
        <Box sx={{ width: 270, flexShrink: 0 }}>
          <Paper
            variant='outlined'
            sx={{ borderRadius: 2, overflow: 'hidden' }}
          >
            {/* Header */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 2,
                py: 1.25,
                bgcolor: '#f8fafc',
                borderBottom: '1px solid #e2e8f0'
              }}
            >
              <Typography
                sx={{ fontSize: 13, fontWeight: 700, color: '#1e293b' }}
              >
                Quote Summary
              </Typography>
              <IconButton
                size='small'
                onClick={() => setSidebarOpen(o => !o)}
                sx={{ p: 0.25 }}
              >
                {sidebarOpen ? (
                  <ExpandLessIcon sx={{ fontSize: 18 }} />
                ) : (
                  <ExpandMoreIcon sx={{ fontSize: 18 }} />
                )}
              </IconButton>
            </Box>

            <Collapse in={sidebarOpen}>
              {/* Route */}
              <Box sx={{ px: 2, pt: 1.5, pb: 1 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.75,
                    mb: 1
                  }}
                >
                  <RouteIcon sx={{ fontSize: 13, color: '#64748b' }} />
                  <Typography
                    sx={{
                      fontSize: 11,
                      fontWeight: 600,
                      color: '#475569',
                      textTransform: 'uppercase',
                      letterSpacing: 0.5
                    }}
                  >
                    Route
                  </Typography>
                </Box>

                <Box
                  sx={{ display: 'flex', gap: 1.25, alignItems: 'flex-start' }}
                >
                  {/* Pin + dashed line */}
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      pt: 0.25
                    }}
                  >
                    <LocationOnIcon sx={{ fontSize: 15, color: '#22c55e' }} />
                    <Box
                      sx={{
                        width: 0,
                        borderLeft: '1.5px dashed #cbd5e1',
                        height: 28,
                        my: 0.25
                      }}
                    />
                    <LocationOnIcon sx={{ fontSize: 15, color: '#ef4444' }} />
                  </Box>

                  {/* Addresses */}
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Box sx={{ mb: 1.5 }}>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: '#1e293b',
                          wordBreak: 'break-word'
                        }}
                      >
                        {originLoc}
                      </Typography>
                      <Typography sx={{ fontSize: 10, color: '#94a3b8' }}>
                        Pickup
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: '#1e293b',
                          wordBreak: 'break-word'
                        }}
                      >
                        {destinationLoc}
                      </Typography>
                      <Typography sx={{ fontSize: 10, color: '#94a3b8' }}>
                        Delivery
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Divider />

              {/* Shipment Details */}
              <Box sx={{ px: 2, pt: 1.25, pb: 1 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.75,
                    mb: 1
                  }}
                >
                  <LocalShippingOutlinedIcon
                    sx={{ fontSize: 13, color: '#64748b' }}
                  />
                  <Typography
                    sx={{
                      fontSize: 11,
                      fontWeight: 600,
                      color: '#475569',
                      textTransform: 'uppercase',
                      letterSpacing: 0.5
                    }}
                  >
                    Shipment Details
                  </Typography>
                </Box>

                {summaryRows.map(({ label, value, valueColor }) => (
                  <Box
                    key={label}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      py: 0.5
                    }}
                  >
                    <Typography sx={{ fontSize: 12, color: '#64748b' }}>
                      {label}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: valueColor || '#1e293b'
                      }}
                    >
                      {value}
                    </Typography>
                  </Box>
                ))}

                {commodityRows.map((c, i) => (
                  <Box
                    key={i}
                    sx={
                      commodityRows.length > 1
                        ? {
                            mt: 0.75,
                            pt: 0.5,
                            borderTop: '1px dashed #e2e8f0'
                          }
                        : {}
                    }
                  >
                    {commodityRows.length > 1 && (
                      <Typography
                        sx={{ fontSize: 10, color: '#94a3b8', mb: 0.25 }}
                      >
                        Commodity {i + 1}
                      </Typography>
                    )}
                    {[
                      { label: 'Freight Class', value: c.freightClass || '-' },
                      {
                        label: 'Pallets / Pieces',
                        value: `${c.units || 0} / ${c.pieces || 0}`
                      },
                      {
                        label: 'Stackable',
                        value: c.isStackable ? 'Yes' : 'No',
                        valueColor: c.isStackable ? '#16a34a' : undefined
                      }
                    ].map(({ label, value, valueColor }) => (
                      <Box
                        key={label}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          py: 0.5
                        }}
                      >
                        <Typography sx={{ fontSize: 12, color: '#64748b' }}>
                          {label}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: valueColor || '#1e293b'
                          }}
                        >
                          {value}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Box>

              <Divider />

              {/* Quote Totals */}
              <Box sx={{ px: 2, pt: 1.25, pb: 1 }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.75,
                    mb: 1
                  }}
                >
                  <EqualizerIcon sx={{ fontSize: 13, color: '#64748b' }} />
                  <Typography
                    sx={{
                      fontSize: 11,
                      fontWeight: 600,
                      color: '#475569',
                      textTransform: 'uppercase',
                      letterSpacing: 0.5
                    }}
                  >
                    Quote Totals
                  </Typography>
                </Box>

                {quoteTotals ? (
                  <>
                    {[
                      {
                        label: 'Total Results',
                        value: quoteTotals.totalResults,
                        color: undefined
                      },
                      {
                        label: 'Lowest Price',
                        value: formatCurrency(quoteTotals.lowestPrice),
                        color: '#16a34a'
                      },
                      {
                        label: 'Fastest Transit',
                        value: quoteTotals.fastestTransit
                          ? `${quoteTotals.fastestTransit} Days`
                          : '-',
                        color: '#2563eb'
                      },
                      {
                        label: 'Average Price',
                        value: formatCurrency(quoteTotals.averagePrice),
                        color: undefined
                      }
                    ].map(({ label, value, color }) => (
                      <Box
                        key={label}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          py: 0.5
                        }}
                      >
                        <Typography sx={{ fontSize: 12, color: '#64748b' }}>
                          {label}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: color || '#1e293b'
                          }}
                        >
                          {value}
                        </Typography>
                      </Box>
                    ))}
                  </>
                ) : (
                  <Typography
                    sx={{ fontSize: 11, color: '#94a3b8', fontStyle: 'italic' }}
                  >
                    Loading rates…
                  </Typography>
                )}
              </Box>

              <Divider />

              {/* Disclaimer */}
              <Box
                sx={{
                  px: 2,
                  py: 1.25,
                  bgcolor: '#f8fafc',
                  display: 'flex',
                  gap: 0.75,
                  alignItems: 'flex-start'
                }}
              >
                <InfoOutlinedIcon
                  sx={{
                    fontSize: 13,
                    color: '#94a3b8',
                    mt: 0.15,
                    flexShrink: 0
                  }}
                />
                <Typography
                  sx={{ fontSize: 10.5, color: '#94a3b8', lineHeight: 1.5 }}
                >
                  <strong style={{ display: 'block', marginBottom: 2 }}>
                    Disclaimer
                  </strong>
                  Rates are estimates and subject to change. Additional charges
                  may apply.
                </Typography>
              </Box>
            </Collapse>
          </Paper>
        </Box>
      )}

      {/* ── Right Panel ── */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <QuickQuoteTabPanel
          OriginLocation={originLoc}
          DestinationLocation={destinationLoc}
          OrderWeight={requoteWeight}
          selectedClass={selectedClass}
          errorMessageApi={errorMessageApi}
          quote={quote}
          fetchData={fetchData}
          obj={obj}
          SelectedRowData={SelectedRowData}
          successRates={successRates}
          EstesApiLoading={EstesApiLoading}
          checkedProp={checked}
          shipTypeValue={shipTypeValue}
          noAssignedCarriers={noAssignedCarriers}
          selectedLocation={selectedLocation}
        />
      </Box>
    </Box>
  );
}

export default React.memo(QuickQuoteRates);
